import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import các file ngôn ngữ
// @ts-ignore
import enTranslation from "./locales/en/index.js";
import enCommon from "./locales/en/common.json";
import enUser from "./locales/en/user.json";
import enProfile from "./locales/en/profile.json";
import enSubscription from "./locales/en/subscription.json";
import enDashboard from "./locales/en/dashboard.json";
import enAI from "./locales/en/ai.json";
import enNav from "./locales/en/nav.json";
import enCatalog from "./locales/en/catalog.json";
import enCourses from "./locales/en/courses.json";
import enFamilyEducation from "./locales/en/family-education.json";
import enAuth from "./locales/en/auth.json";
import enMobile from "./locales/en/mobile.json";
import enBuddhism from "./locales/en/buddhism.json";
import enFamily from "./locales/en/family.json";
import enWidgets from "./locales/en/widgets.json";
import enMenu from "./locales/en/menu.json";

// Import admin ngôn ngữ tiếng Anh
import enAdminDashboard from "./locales/en/admin/admin-dashboard.json";

// Import các file ngôn ngữ tiếng Việt
// @ts-ignore
import viIndex from "./locales/vi/index.js";
import viTranslation from "./locales/vi/translation.json";
import viCommon from "./locales/vi/common.json";
import viUser from "./locales/vi/user.json";
import viProfile from "./locales/vi/profile.json";
import viSubscription from "./locales/vi/subscription.json";
import viDashboard from "./locales/vi/dashboard.json";
import viAI from "./locales/vi/ai.json";
import viNav from "./locales/vi/nav.json";
import viCatalog from "./locales/vi/catalog.json";
import viCourses from "./locales/vi/courses.json";
import viFamilyEducation from "./locales/vi/family-education.json";
import viMobile from "./locales/vi/mobile.json";
import viAuth from "./locales/vi/auth.json";
import viBuddhism from "./locales/vi/buddhism.json";
import viFamily from "./locales/vi/family.json";
import viWidgets from "./locales/vi/widgets.json";
import viMenu from "./locales/vi/menu.json";

// Import admin ngôn ngữ tiếng Việt
import viAdminDashboard from "./locales/vi/admin/admin-dashboard.json";

// Import hỗ trợ tiếng Pali
import piCatalog from "./locales/pi/catalog.json";
import piCommon from "./locales/pi/common.json";
import piMenu from "./locales/pi/menu.json";

// Try-catch để xử lý trường hợp file không tồn tại
let piBuddhism = {};
try {
  // @ts-ignore - Dynamic import
  piBuddhism = require("./locales/pi/buddhism.json");
} catch (error) {
  console.warn(
    "Không tìm thấy file buddhism.json trong thư mục locales/pi, sử dụng object rỗng thay thế",
  );
}

// Try-catch để xử lý trường hợp file family.json tiếng Pali không tồn tại
let piFamily = {};
try {
  // @ts-ignore - Dynamic import
  piFamily = require("./locales/pi/family.json");
} catch (error) {
  console.warn(
    "Không tìm thấy file family.json trong thư mục locales/pi, sử dụng object rỗng thay thế",
  );
}

// Thêm postProcessor để xử lý key dạng a.b tương tự như a:b
i18n.services.formatter?.add('dotHandler', (value, format, lng, options) => {
  // Chỉ xử lý khi có giá trị value là undefined (không tìm thấy key)
  if (value === undefined || value === null) {
    const key = options.originalKey || '';
    if (key && key.includes('.')) {
      const [ns, ...keyParts] = key.split('.');
      const actualKey = keyParts.join('.');
      // Thử tìm key trong namespace
      try {
        return i18n.t(`${ns}:${actualKey}`);
      } catch (error) {
        return key;
      }
    }
  }
  return value; // Nếu đã có giá trị, trả về nguyên bản
});

// Cấu hình i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
        common: enCommon,
        user: enUser,
        profile: enProfile,
        subscription: enSubscription,
        dashboard: enDashboard,
        ai: enAI,
        nav: enNav,
        catalog: enCatalog,
        courses: enCourses,
        "family-education": enFamilyEducation,
        auth: enAuth,
        mobile: enMobile,
        "admin-dashboard": enAdminDashboard,
        buddhism: enBuddhism,
        family: enFamily,
        widgets: enWidgets,
        menu: enMenu,
      },
      vi: {
        translation: { ...viIndex, ...viTranslation },
        common: viCommon,
        user: viUser,
        profile: viProfile,
        subscription: viSubscription,
        dashboard: viDashboard,
        ai: viAI,
        nav: viNav,
        catalog: viCatalog,
        courses: viCourses,
        "family-education": viFamilyEducation,
        mobile: viMobile,
        auth: viAuth,
        "admin-dashboard": viAdminDashboard,
        buddhism: viBuddhism,
        family: viFamily,
        widgets: viWidgets,
        menu: viMenu,
      },
      pi: {
        translation: {},
        common: piCommon,
        catalog: piCatalog,
        buddhism: piBuddhism || {},
        family: piFamily || {},
        menu: piMenu,
      },
    },
    lng: "vi", // Ngôn ngữ mặc định
    fallbackLng: {
      default: ["vi"],
      en: ["vi"],
      pi: ["vi", "en"],
    },
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    defaultNS: "catalog",
    ns: [
      "translation",
      "common",
      "user",
      "profile",
      "subscription",
      "dashboard",
      "ai",
      "nav",
      "catalog",
      "courses",
      "buddhism",
      "family",
      "family-education",
      "mobile",
      "auth",
      "admin-dashboard",
      "widgets",
      "menu",
    ],
    parseMissingKeyHandler: (key) => {
      console.warn(`Missing translation key: ${key}`);
      // Trả về key thô thay vì translation key
      const parts = key.split(":");
      if (parts.length > 1) {
        return parts[parts.length - 1];
      }
      const lastPart = key.split(".").pop();
      return lastPart || key;
    },
    keySeparator: ".", // Sử dụng dấu chấm làm phân cách cho JSON phẳng
    nsSeparator: ":",  // Sử dụng dấu hai chấm làm phân cách namespace
    fallbackNS: ["common", "ai", "mobile", "menu", "catalog"], 
    postProcess: 'dotHandler'
  });

export default i18n;
